/**
 * throttle — يمنع تنفيذ callback أكثر من مرة واحدة خلال فترة محددة
 * يُستخدم في الـ realtime listeners لمنع تكرار re-render المستمر
 */

export function throttle<T extends (...args: unknown[]) => void>(
  fn: T,
  wait: number
): T {
  let lastTime = 0;
  let timer: ReturnType<typeof setTimeout> | null = null;

  return ((...args: unknown[]) => {
    const now = Date.now();
    if (now - lastTime >= wait) {
      lastTime = now;
      if (timer) { clearTimeout(timer); timer = null; }
      fn(...args);
    } else {
      // Schedule one final call after the wait period
      if (!timer) {
        timer = setTimeout(() => {
          lastTime = Date.now();
          timer = null;
          fn(...args);
        }, wait - (now - lastTime));
      }
    }
  }) as T;
}

/**
 * debounce — ينتظر انتهاء سلسلة من الأحداث قبل تنفيذ callback
 * يُستخدم في inputs والبحث
 */
export function debounce<T extends (...args: unknown[]) => void>(
  fn: T,
  wait: number
): T {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return ((...args: unknown[]) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, wait);
  }) as T;
}